import React from "react";
import styled from "styled-components";
import Skeleton from "./Skeleton";

const CardContainer = styled.div`
    min-width: 0;
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-rows: minmax(0, 1fr) auto;
    gap: 0.65rem;
    animation: statistics-card-enter 0.22s ease both;

    @keyframes statistics-card-enter {
        from {
            opacity: 0;
            transform: translateY(6px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;

const ContentContainer = styled.div`
    min-height: 74px;
    margin-right: 0;
    display: grid;
    padding: 0.65rem 1rem 0.9rem;
    overflow: hidden;
    box-sizing: border-box;
`;

const ContentWrapper = styled.div`
    display: flex;
    height: 100%;
    justify-content: flex-end;
    align-items: flex-start;
    flex-direction: column;
    min-width: 0;
`;

const Card = styled.div`
    width: 100%;
    min-height: ${p => p.cardHeight || "116px"};
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: ${p => p.cardShadow || "0 18px 36px rgba(29, 42, 89, 0.08)"};
    border: 1px solid #D8DEEC;
    border-radius: 12px;
    overflow: hidden;
    transition: transform 0.16s ease, border-color 0.16s ease, box-shadow 0.16s ease;

    &:hover {
        border-color: #C9D2E7;
        box-shadow: ${p => p.cardShadow || "0 14px 28px rgba(29, 42, 89, 0.09)"};
        transform: translateY(-1px);
    }
`;

const CardHeader = styled.div`
    min-height: 2.25rem;
    margin: 0;
    padding: 0.75rem 1rem;
    width: auto;
    text-align: left;
    font-size: .75rem;
    font-weight: 800;
    line-height: 1.35;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #171A22;
    opacity: 1;
    overflow-wrap: anywhere;
`;

const Hr = styled.div`
    height: 1px;
    background: #D8DEEC;
`;

const TextLabel = styled.div`
    text-align: left;
    font: normal normal 500 0.8125rem/1.45 Manrope;
    letter-spacing: 0;
    color: #6A7387;
    opacity: 1;
    margin: 0;
    min-height: 2.375rem;
    overflow-wrap: anywhere;
`;

const SkeletonContainer = styled.div`
    margin: .5rem 1rem;
`;

const MoodRatingContainer = styled.div`
    margin: 0;
    font-size: 1.55rem;
    font-weight: 800;
    width: 100%;
    flex-direction: row;
    display: flex;
    min-width: 0;
    overflow-wrap: anywhere;

    @media (max-width: 520px) {
        font-size: 1.35rem;
    }
`;

const MoodRatingCard = (props, children) => {
    const { header, footer, loadingBaseNumbers, cardHeight, loadingLineGraph, moodData, printFormat } = props;
    const moodEmoji = {
        happy: "😁",
        content: "😊",
        neutral: "😐",
        sad: "😔",
        unhappy: "😢",
        tired: "😴",
        stressed: "😬",
        sick: "🤒",
    };
    return (
        <>
            <CardContainer>
                <Card cardHeight={cardHeight} cardShadow={printFormat ? "unset" : undefined}>
                    <CardHeader>
                        {loadingBaseNumbers ?
                            <Skeleton variant="Text" width="100px" height="20px" animation="wave" />
                            : header
                        }
                    </CardHeader>
                    <Hr />
                    {loadingBaseNumbers ?
                        <SkeletonContainer>
                            <Skeleton variant="Text" width="50px" height="33px" animation="wave" />
                        </SkeletonContainer>
                        :
                        <ContentContainer>
                            <ContentWrapper>
                                { loadingLineGraph ?
                                    <SkeletonContainer>
                                        <Skeleton variant="Text" width="60px" height="40px" animation="wave" />
                                    </SkeletonContainer>
                                    :
                                    <MoodRatingContainer>
                                        <div style={{ margin: "0px 10px 0px 0px", textTransform: "capitalize" }}>
                                            { moodData.overAllMoodRating && moodData.overAllMoodRating !== "No Data" && !loadingLineGraph ?
                                                `${moodEmoji[moodData.overAllMoodRating]} ${moodData.overAllMoodRating}`
                                                : "No Data" 
                                            }
                                        </div>
                                    </MoodRatingContainer>
                                }
                            </ContentWrapper>
                        </ContentContainer>
                    }
                </Card>
                <TextLabel size=".5rem">
                    {footer}
                </TextLabel>
            </CardContainer>
        </>
    );
};
export default MoodRatingCard;
